<template>
  <div class="createGame">
    <h3>Создать игру</h3>
    <el-row>
      <el-col :span="6">Название</el-col>
      <el-col :span="18"><el-input v-model="name" /></el-col>
    </el-row>
    <el-row>
      <el-col :span="6">Дата</el-col>
      <el-col :span="18"><el-date-picker v-model="date" type="date"/></el-col>
    </el-row>
    <el-row>
      <el-col :span="6">Количество раундов</el-col>
      <el-col :span="18"><el-input-number :min="1" :max="20" v-model="numRounds" /> </el-col>
    </el-row>
    <hr/>
    <h6>Раунды</h6>
    <el-collapse :accordion="true">
      <el-collapse-item v-for="(_, roundIndex) in rounds" :name="`Раунд-${roundIndex}`" :key="roundIndex">
        <div class="round-header" slot="title">Раунд-{{roundIndex+1}}</div>
        <div class="round-body">
          
          <el-row>
            <el-col :span="6">Название раунда</el-col>
            <el-col :span="18"><el-input v-model="rounds[roundIndex].name" /></el-col>
          </el-row>
          <el-row>
            <el-col :span="6">Количество вопросов в раунде</el-col>
            <el-col :span="18"><el-input-number :min="1" :max="20" v-model="rounds[roundIndex]._numQuestions" /></el-col>
          </el-row>
          <el-row v-for="(_, answerIndex) in rounds[roundIndex].answers" :key="`question_${roundIndex}_${answerIndex}`">
            <el-col :span="6">Ответ(ы) на вопрос {{answerIndex+1}}</el-col>
            <el-col :span="18">
              <el-input type="textarea" v-model="rounds[roundIndex].answers[answerIndex]" :rows="3"></el-input>
            </el-col>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="controls">
      <el-button type="success" @click="save">Сохранить игру</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'createGame',
  data() {
    return {
      name: null,
      date: null, 
      numRounds: 1,      
      rounds:[{name:"", _numQuestions: 1, answers:[""]}]
    }
  },
  methods: {
    save() {
      const gamedata = {name: this.name, date: this.date, rounds: this.rounds};
      this.$store.dispatch('createGame', gamedata)
        .then(gameid => this.$router.push(`/admin/games/${gameid}`))
        .catch(err => this.$message({type: 'error', message: err.message}));
    },
  },
  computed:{
  },
  watch: {
    numRounds(newVal) {
      this.rounds = [
        ...this.rounds.slice(0, newVal),
        ...Array(Math.max(newVal - this.rounds.length, 0)).fill({name: "", _numQuestions:1, answers: [""]})
      ];
    },

    rounds: {
      handler(newVal, oldVal) {
        if(newVal.length == oldVal.length) {
          newVal.forEach(round => {
            if(round._numQuestions != round.answers.length) {
              round.answers = [
                ...round.answers.slice(0, round._numQuestions),
                ...Array(Math.max(round._numQuestions - round.answers.length,0)).fill("")
              ];              
            }
          });
        }
      },
      deep: true
    }
  },
}
</script>

<style scoped>
  .createGame {
    padding: 20px;
    background-color:aliceblue;
  }
  .controls{
    margin-top: 20px;
  }
  .round-header {
    margin: 20px;
  }
  .round-body {
    margin: 20px;
  }
</style>